import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerV2InitialState, basedDataReducerV2 } from 'redux/base-reducer-v2';

import { IEecsCertificateModal, IGoCertificate } from '../types/eecs-certificates.type';

export interface GoCertificateInitialState extends BaseDataReducerV2InitialState<IGoCertificate> {
  currentModal: IEecsCertificateModal | null;
  selectedCertificate: IGoCertificate | null;
}

const { initialState, AC, reducer, thunks } = basedDataReducerV2<IGoCertificate, GoCertificateInitialState>(
  'necs-go-certificate',
);

export const goCertificateInitialState: GoCertificateInitialState = {
  ...initialState,
  perPage: 25,
  currentModal: null,
  selectedCertificate: null,
};

export const eecsGoCertificate = createSlice({
  name: 'eecsGoCertificate',
  initialState: goCertificateInitialState,
  reducers: {
    setCertificateModal: (state, action: PayloadAction<IEecsCertificateModal | null>) => {
      state.currentModal = action.payload;
    },
    setSelectedCertificate: (state, action: PayloadAction<IGoCertificate | null>) => {
      state.selectedCertificate = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as GoCertificateInitialState, action);
    });
  },
});

export const GoCertificateAC = AC;
export const onGoCertificateSort = thunks.onSort;
export const onGoCertificateFilter = thunks.onFilter;
export const clearGoCertificateFilters = AC.clearFilters;
export const setGoCertificateCurrentPage = AC.setCurrentPage;

export const { setCertificateModal, setSelectedCertificate } = eecsGoCertificate.actions;
